import HelpCollapsable from './HelpCollapsable'

export default HelpCollapsable
